export * from './report.component';



// WEBPACK FOOTER //
// ./src/app/layout/report/index.ts